import React from 'react';
import { Link } from 'react-router-dom';
import { SideBar } from '../Common/SideBar';
import { DashboardHeader } from '../Common/DashboardHeader';
import { Footer } from '../Common/Footer';
import seller from '../../Models/seller';
import { Header } from '../Common';
import { Spinner } from 'reactstrap';
import {withTranslation} from "react-i18next";


class SellerEstimate extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert(this.props.t('SELLER_SERVICE_LIST.LOGIN_ALERT'))
            this.props.history.push('/login/seller');
        };
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        this.state = {
            minHeight: "475px",
            estimationList: [],
            user: '',
            status: '',
            loaded: false,
        };
        this.state.user = logged_user.id;


    }
    async componentDidMount() {
        await this.getEstimationList();
        this.setState({ loaded: true })
    }
    getEstimationList() {
        var x = JSON.parse(localStorage.getItem('info'))
        seller.getEstimation(x.id).then(res => {
            this.setState({ estimationList: res.data.payload, status: res.data.status })
        })
    }
    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        // console.log('asd')
        e.preventDefault();
        let data = {
        }
        console.log(data);
        // this.props.buyerLogin(data);
    }

    sellerEstimation() {
        console.log(this.state.estimationList.length)
        if (this.state.status === 200) {
            if (this.state.estimationList.length == 0) {
                return (
                    <div>
                        {/* <div className="mt-3"> */}
                        <span><img alt="" src={require("../../assets/images/edit.png")} height="40" width='40' />&nbsp;&nbsp;</span>
                        {/* </div> */}
                        <div className="mt-3">
                            <span>{this.props.t('SELLER_TRANSACTION.NO_QUOTE')}</span>
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <div style={{ backgroundColor: "white", minHeight: "550px", textAlign: "left" }}>
                        <div className="col-md-12 row ml-2" style={{ paddingTop: "3%", paddingBottom: "2%" }}>
                            <div className="col-md-4 font_12">
                                <b><i>{this.props.t('SELLER_TRANSACTION.TRANS_DETAILS')} </i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i>{this.props.t('SELLER_TRANSACTION.PROPOSAL_DEADLINE')}</i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i>{this.props.t('SELLER_TRANSACTION.TRANS_AMOUNT')}</i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i>{this.props.t('SELLER_TRANSACTION.STATUS')}</i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                {/* <b><i>{this.props.t('SELLER_TRANSACTION.STATUS')}</i></b> */}
                            </div>
                        </div>
                        {this.state.estimationList.map((req, i = 1) =>
                            <div className="col-md-12 row ml-2" key={req.id} style={{ borderBottom: "1px solid #fbf8f8", paddingTop: "3%", paddingBottom: "2%" }}>
                                <div className="col-md-4 font_12">
                                    {/* <span className="font_12"> サービスID: {req.id}</span><br /> */}
                                    <Link to={{
                                        pathname: `/request-details/${req.id}`,
                                        state: {
                                            id: req.id,
                                            user: this.state.user
                                        }
                                    }}>
                                        <b>{req.title}</b>
                                    </Link>
                                </div>
                                <div className="col-md-2 font_12" style={{}}>
                                    {(JSON.stringify(req.application_date)).substring(1, 11)}
                                </div>
                                <div className="col-md-2 font_12" style={{}}>
                                    {req.budget_range}
                                </div>
                                <div className="col-md-2">
                                    {(() => {
                                        if (req.current_status === 'TRADING') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}> {this.props.t('SELLER_TRANSACTION.PENDING')}</div>
                                            )
                                        } else if (req.current_status === 'UNDERESTIMATION') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('SELLER_TRANSACTION.CONSULT_STATUS')}</div>
                                            )
                                        } else if (req.current_status === 'COMPLETE') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('SELLER_TRANSACTION.COMPLETE_STATUS')}</div>
                                            )
                                        } else if (req.current_status === 'CANCEL') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('SELLER_TRANSACTION.CANCEL_BTN')}</div>
                                            )
                                        } else if (req.current_status === 'DECLINED') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('SELLER_TRANSACTION.REJECTION')}</div>
                                            )
                                        } else {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('SELLER_TRANSACTION.NOT_CLEAR')}</div>
                                            )
                                        }
                                    })()}
                                </div>
                                <div className="col-md-2 font_12">
                                    <Link to={{
                                        pathname: `/seller-direct-message`,
                                        state: {
                                            buyer_id: req.buyer_id,
                                            seller_id: req.accepted_seller_id
                                        }
                                    }}>
                                        <button
                                            style={{
                                                padding: "10%", border: "1px solid cadetblue",
                                                borderRadius: "4px", color: "green", background: "white"
                                            }}>
                                            {this.props.t('SELLER_TRANSACTION.CHAT_BTN')}
                                            </button>
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>

                )
            }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '100px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }
    }
    sellerEstimationSmall() {
        console.log(this.state.estimationList.length)
        if (this.state.status === 200) {
            if (this.state.estimationList.length == 0) {
                return (
                    <div>
                        {/* <div className="mt-3"> */}
                        <span><img alt="" src={require("../../assets/images/edit.png")} height="40" width='40' />&nbsp;&nbsp;</span>
                        {/* </div> */}
                        <div className="mt-3">
                            <span>{this.props.t('SELLER_TRANSACTION.NO_QUOTE')}</span>
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <div style={{ backgroundColor: "white", minHeight: "550px", textAlign: "left" }}>
                        {this.state.estimationList.map((req, i = 1) =>
                            <div className="ml-2 pl-1" key={req.id} style={{ borderBottom: "1px solid #dadada", paddingTop: "3%", paddingBottom: "3%"}}>
                                <div className="font_12 pb-3" style={{paddingLeft: "15px"}}>
                                    {/* <span className="font_12"> サービスID: {req.id}</span><br /> */}
                                    <Link to={{
                                        pathname: `/request-details/${req.id}`,
                                        state: {
                                            id: req.id,
                                            user: this.state.user
                                        }
                                    }}>
                                        <b class="gray">{req.title}</b>
                                    </Link>
                                </div>
                                <div className="font_12 row col" style={{}}>
                                    <div className="col-4 text-left">{req.budget_range}</div>
                                    <div className="col-4 text-right remove_pads">{(JSON.stringify(req.application_date)).substring(1, 11)}</div>
                                    <div className="col-4 text-right pr-1">
                                        {(() => {
                                            if (req.current_status === 'TRADING') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}> {this.props.t('SELLER_TRANSACTION.PENDING')}</div>
                                                )
                                            } else if (req.current_status === 'UNDERESTIMATION') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('SELLER_TRANSACTION.CONSULT_STATUS')}</div>
                                                )
                                            } else if (req.current_status === 'COMPLETE') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('SELLER_TRANSACTION.COMPLETE_STATUS')}</div>
                                                )
                                            } else if (req.current_status === 'CANCEL') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('SELLER_TRANSACTION.CANCEL_BTN')}</div>
                                                )
                                            } else if (req.current_status === 'DECLINED') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('SELLER_TRANSACTION.REJECTION')}</div>
                                                )
                                            } else {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('SELLER_TRANSACTION.NOT_CLEAR')}</div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                                <div className="col-12">&nbsp;</div>
                                <div className="col-md-2 font_12 text-center">
                                    <Link to={{
                                        pathname: `/seller-direct-message`,
                                        state: {
                                            buyer_id: req.buyer_id,
                                            seller_id: req.accepted_seller_id
                                        }
                                    }}>
                                        <button
                                            style={{
                                                padding: "1%", border: "1px solid cadetblue",
                                                borderRadius: "4px", color: "green", background: "white"
                                            }}>
                                            {this.props.t('SELLER_TRANSACTION.CHAT_BTN')}
                                            </button>
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>

                )
            }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '100px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mt-5 input_name big_font text-left" style={{ width: "100%" ,fontSize:'20px'}}>
                                    {this.props.t('SELLER_TRANSACTION.SELLER_TRANS_TITLE')}
                                    </div>
                                <div className="chest">
                                    <div>
                                        <div className="row" style={{ marginLeft: '0px', marginRight: '-8px' }}>
                                            <div className="navigation" style={{ borderTop: "4px solid #67b1e2", borderBottom: "1px solid white",fontSize: "9px",width: "33%",paddingRight:'3%' }}>
                                                <Link to={'/seller-estimate'} className="h-a" href=""><b>{this.props.t('SELLER_TRANSACTION.ESTIMATION')}</b></Link>
                                            </div>
                                            <div className="navigation"style={{ width: "33%",paddingRight:'3%',fontSize: "9px" }}>
                                                <Link to={'/seller-transaction'} className="h-a" href=""> {this.props.t('SELLER_TRANSACTION.PENDING')}</Link>
                                            </div>
                                            <div className="navigation"style={{ width: "32%" ,paddingRight:'2%',fontSize: "9px"}}>
                                                <Link to={'/seller-complete-cancel'} className="h-a" href="">{this.props.t('SELLER_TRANSACTION.DONE_CANCEL')}</Link>
                                            </div>
                                        </div>
                                        <div>
                                            <div colSpan="3">
                                                <div className="min-height">
                                                    {/* <p>check the query</p> */}
                                                    <div className="">
                                                        {this.state.loaded ? this.sellerEstimationSmall() : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: "100%" }}>
                                            {this.props.t('SELLER_TRANSACTION.SELLER_TRANS_TITLE')}
                                    </div>
                                        <div className="chest">
                                            <div>
                                                <div className="row" style={{ marginLeft: '0px', marginRight: '-8px' }}>
                                                    <div className="navigation" style={{ borderTop: "4px solid #67b1e2", borderBottom: "1px solid white" }}>
                                                        <Link to={'/seller-estimate'} className="h-a" href=""><b>{this.props.t('SELLER_TRANSACTION.ESTIMATION')}</b></Link>
                                                    </div>
                                                    <div className="navigation">
                                                        <Link to={'/seller-transaction'} className="h-a" href=""> {this.props.t('SELLER_TRANSACTION.PENDING')}</Link>
                                                    </div>
                                                    <div className="navigation">
                                                        <Link to={'/seller-complete-cancel'} className="h-a" href="">{this.props.t('SELLER_TRANSACTION.DONE_CANCEL')}</Link>
                                                    </div>
                                                </div>
                                                {/* <tr>
                                                <td colSpan="3">
                                                    <div className="transaction-inputs col-md-12 row ml-2">
                                                        <div className="col-md-4" style={{ textAlign: "center" }}><input className="oneofthree" style={{ width: "80%" }} /></div>
                                                        <div className="col-md-4" style={{ textAlign: "center" }}>
                                                            <select className="oneofthree" style={{ width: "80%" }}>
                                                                <option>
                                                                </option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4" style={{ textAlign: "center" }}>
                                                            <button className="third-button" style={{ paddingLeft: "2%", paddingRight: "2%", fontSize: "12px" }}>Narrow Down</button>
                                                            <p>search by text and category to be added later</p>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr> */}
                                                <div>
                                                    <div colSpan="3">
                                                        <div className="min-height">
                                                            {/* <p>check the query</p> */}
                                                            <div className="">
                                                                {this.state.loaded ? this.sellerEstimation() : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
    }
}

// const mapStateToProps = (state) => ({
// buyerLogin: state.buyerLogin,
// });

// BuyerLogin = connect(mapStateToProps, { buyerLogin })(BuyerLogin);

export { SellerEstimate };
SellerEstimate = withTranslation('seller')(SellerEstimate)
